import logo from '../../assets/logo.svg';

export const Logo = ({ width = '200px' }) => {
  return (
    <img
      style={{ width: width, height: 'auto' }}
      src={logo}
      alt='Solex Connect'
    />
  );
};
